export default __webpack_public_path__ + "static/assets/698ef15131ee7afb084c77ddf3f15ba3.png";